import { SearchModes } from '@/domainLogic/index.ts';
import { type SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';
import { FlightClassType } from './FlightClassType.ts';

export const getBooleanFromString = (input: string): boolean => input === 'true' || input === '1';

export const getFlightClassFromString = (flightClassString: string): FlightClassType | undefined =>
  (Object.values(FlightClassType) as string[]).includes(flightClassString)
    ? (flightClassString as FlightClassType)
    : undefined;

export const getSearchModeFromString = (searchModeString: string): SearchModes =>
  (Object.values(SearchModes) as string[]).includes(searchModeString)
    ? (searchModeString as SearchModes)
    : SearchModes.DP;

export const getSearchModeFromSearchParams = (searchParams: SearchParams): SearchModes =>
  getSearchModeFromString(searchParams?.[URLParameters.SEARCH_MODE] || '');

export const getSortFromString = (sortString: string): SortValues =>
  (Object.values(SortValues) as string[]).includes(sortString) ? (sortString as SortValues) : SortValues.Recommended;
